import { render, staticRenderFns } from "./selectPolicyOrderThreshold.vue?vue&type=template&id=f547b880&scoped=true"
import script from "./selectPolicyOrderThreshold.vue?vue&type=script&lang=js"
export * from "./selectPolicyOrderThreshold.vue?vue&type=script&lang=js"
import style0 from "./selectPolicyOrderThreshold.vue?vue&type=style&index=0&id=f547b880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f547b880",
  null
  
)

export default component.exports